import { render, staticRenderFns } from "./preview-resource.vue?vue&type=template&id=bcbefefc&scoped=true"
import script from "./preview-resource.vue?vue&type=script&lang=js"
export * from "./preview-resource.vue?vue&type=script&lang=js"
import style0 from "./preview-resource.vue?vue&type=style&index=0&id=bcbefefc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbefefc",
  null
  
)

export default component.exports